import { notify } from './NotifierReducer';
import store from '../config/configureStore';
import buildInfo from '../config/buildInfo.json';
import casesTableConfig from '../config/cases-table-config.json';
import eventsConfig from '../config/events-config.json';
import { showSpinner, hideSpinner } from './UiReducer';
import appConfig from '../config/appConfig.json';

const FIND_CASES =          'VFC/FIND_CASES';
const GET_CASE =            'VFC/GET_CASE';
const LOADING_CASES =       'VFC/LOADING_CASES';
const LOADING_CASES_ERROR = 'VFC/LOADING_CASES_ERROR';
const FIND_EVENTS =         'VFC/FIND_EVENTS';
const GET_EVENT =           'VFC/GET_EVENT';
const LOADING_EVENTS =      'VFC/LOADING_EVENTS';
const LOADING_EVENTS_ERROR = 'VFC/LOADING_EVENTS_ERROR';
const GET_API_VER =         'VFC/GET_API_VER';
const PRINT_DATA =          'VFC/PRINT_DATA';

// ======================= ACTIONS =======================

export const findCases = params => {
  return async dispatch => {
    const state = store.store.getState();
    const client = state.websocket.websocket;
    try {
      const service = client.service('archive-browser');
      service.timeout = 20000;
      dispatch({ type: LOADING_CASES, payload: true });
      const cases = await service.find({ query: { ...params, type: 'cases' }});
      dispatch({ type: FIND_CASES, payload: { params, cases } });
      dispatch({ type: LOADING_CASES, payload: false });
    } catch (error) {
      dispatch({ type: LOADING_CASES_ERROR });
      dispatch(notify('Error, data not received #CA1', 'error'));
    }
  };
};

export const sortCases = orderBy => {
  return async dispatch => {
    const changeDirection = direction => (direction === 'ASC' ? 'DESC' : 'ASC');
    const cases = store.store.getState().vfc.cases;
    const { filters, pageNo, rowsPerPage, count } = cases;
    const orderDirection =
      cases.orderBy === orderBy ? changeDirection(cases.orderDirection) : 'ASC';
    const params = { filters, pageNo, orderBy, rowsPerPage, orderDirection, count };
    dispatch(findCases(params));
  };
};

export const getCase = caseId => {
  const state = store.store.getState();
  const client = state.websocket.websocket;
  return async dispatch => {
    dispatch(showSpinner());
    try {
      const service = client.service('archive-browser');
      service.timeout = 20000;
      const row = await service.get({ type: 'cases', data: caseId });
      dispatch({ type: GET_CASE, payload: row });
    } catch (error) {
      dispatch(notify('Error, data not received #CA2', 'error'));
    }
    dispatch(hideSpinner());
  };
};

export const printCasesData = () => {
  return async dispatch => {
    const state = store.store.getState();
    const client = state.websocket.websocket;
    const cases = store.store.getState().vfc.cases;
    try {
      const service = client.service('archive-browser');
      service.timeout = 20000;
      dispatch({ type: LOADING_CASES, payload: true });
      const query = { query: {
         filters: cases.filters, 
         orderBy: cases.orderBy,
         orderDirection: cases.orderDirection,
         type: 'cases',
         pageNo: 0,
         rowsPerPage: appConfig.maxPrintResults
      }};
      const printData = await service.find(query);
      dispatch({ type: PRINT_DATA, payload: printData.result });
      dispatch({ type: LOADING_CASES, payload: false });
    } catch (error) {
      dispatch({ type: LOADING_CASES_ERROR });
      dispatch(notify('Error, data not received #CA3', 'error'));
    }
  };
};

export const clearPrintData = () => {
  return async dispatch => {
    dispatch({ type: PRINT_DATA, payload: null });
  };
}

// ================= EVENTS ===================

export const findEvents = params => {
  return async dispatch => {
    const state = store.store.getState();
    const client = state.websocket.websocket;
    try {
      const service = client.service('archive-browser');
      service.timeout = 20000;
      dispatch({ type: LOADING_EVENTS, payload: true });
      const events = await service.find({ query: { ...params, type: 'events' }});
      dispatch({ type: FIND_EVENTS, payload: { params, events } });
      dispatch({ type: LOADING_EVENTS, payload: false });
    } catch (error) {
      dispatch({ type: LOADING_EVENTS_ERROR });
      dispatch(notify('Error, data not received #EV1', 'error'));
    }
  };
};

export const sortEvents = orderBy => {
  return async dispatch => {
    const changeDirection = direction => (direction === 'ASC' ? 'DESC' : 'ASC');
    const events = store.store.getState().vfc.events;
    const { filters, pageNo, rowsPerPage } = events;
    const orderDirection =
    events.orderBy === orderBy ? changeDirection(events.orderDirection) : 'ASC';
    const params = { filters, pageNo, orderBy, rowsPerPage, orderDirection };
    dispatch(findEvents(params));
  };
};

export const getEvent = dispatchId => {
  const state = store.store.getState();
  const client = state.websocket.websocket;
  return async dispatch => {
    dispatch(showSpinner());
    try {
      const service = client.service('archive-browser');
      service.timeout = 20000;
      const row = await service.get({ type: 'events', data: dispatchId });
      dispatch({ type: GET_EVENT, payload: row });
    } catch (error) {
      dispatch(notify('Error, data not received #EV2', 'error'));
    }
    dispatch(hideSpinner());
  };
};

export const printEventsData = () => {
  return async dispatch => {
    const state = store.store.getState();
    const client = state.websocket.websocket;
    const events = store.store.getState().vfc.events;
    try {
      const service = client.service('archive-browser');
      service.timeout = 20000;
      dispatch({ type: LOADING_EVENTS, payload: true });
      const query = { query: {
         filters: events.filters, 
         orderBy: events.orderBy,
         orderDirection: events.orderDirection,
         type: 'events',
         pageNo: 0,
         rowsPerPage: appConfig.maxPrintResults
      }};
      const printData = await service.find(query);
      dispatch({ type: PRINT_DATA, payload: printData.result });
      dispatch({ type: LOADING_EVENTS, payload: false });
    } catch (error) {
      dispatch({ type: LOADING_EVENTS_ERROR });
      dispatch(notify('Error, data not received #CA3', 'error'));
    }
  };
};

// ======================= REDUCER =======================
const defaultState = {
  cases: {
    rows: [],
    count: 0,
    pageNo: 0,
    search: '',
    rowsPerPage: casesTableConfig.rowsPerPage,
    orderBy: casesTableConfig.orderBy,
    orderDirection: casesTableConfig.orderDirection,
    loading: false,
    loaded: false,
    error: false
  },
  caseDetails: {
    data: null,
    caseId: null
  },
  events: {
    rows: [],
    count: 0,
    pageNo: 0,
    search: '',
    rowsPerPage: eventsConfig.rowsPerPage,
    orderBy: eventsConfig.orderBy,
    orderDirection: eventsConfig.orderDirection,
    loading: false,
    loaded: false,
    error: false
  },
  eventDetails: {
    data: null,
    caseId: null
  },
  printData: null,
  apiVersion: null,
  buildInfo
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    // vfc
    case LOADING_CASES:
      return {
        ...state,
        cases: {
          ...state.cases,
          loading: action.payload,
          loaded: action.payload ? false : state.cases.loaded,
          error: false
        }
      };
    case LOADING_CASES_ERROR:
      return {
        ...state,
        cases: {
          ...state.cases,
          loading: false,
          loaded: true,
          error: true
        }
      };
    case FIND_CASES:
      return {
        ...state,
        cases: {
          rows: formatResultsData(action.payload.cases.result, casesTableConfig),
          ...action.payload.params,
          count: action.payload.cases.count,
          loaded: true,
          error: false
        }
      };
    case GET_CASE:
      return {
        ...state,
        caseDetails: { ...state.caseDetails, data: formatCaseData(action.payload) }
      };
    case LOADING_EVENTS:
      return {
        ...state,
        events: {
          ...state.events,
          loading: action.payload,
          loaded: action.payload ? false : state.events.loaded,
          error: false
        }
      };
    case LOADING_EVENTS_ERROR:
      return {
        ...state,
        events: {
          ...state.events,
          loading: false,
          loaded: true,
          error: true
        }
      };
    case FIND_EVENTS:
      return {
        ...state,
        events: {
          rows: formatResultsData(action.payload.events.result, eventsConfig),
          ...action.payload.params,
          count: action.payload.events.count,
          loaded: true,
          error: false
        }
      };
    case GET_EVENT:
      return {
        ...state,
        eventDetails: { ...state.eventDetails, data: formatCaseData(action.payload) }
      };
    case GET_API_VER:
      return { ...state, apiVersion: action.payload };
    case PRINT_DATA:
      return { ...state, printData: action.payload };
    default:
      return state;
  }
}

// ======================= HELPERS =======================
/** Format data comming from api */
function formatResultsData(rows, config) {
  return rows.map(row => {
    const out = {};
    out.key = row[config.key];
    Object.keys(config.display).forEach(key => {
      let val1 = row[key];
      if (val1 === 'NULL') val1 = '';
      out[key] = val1;
    });
    return out;
  });
}

function formatCaseData(data) {
  const out = { ...data };
  out.AddtlInfo = data.AddtlInfo ? JSON.parse(data.AddtlInfo) : null;
  out.MainInfo = data.MainInfo ? JSON.parse(data.MainInfo) : null;
  return out;
}
